module.exports = __webpack_public_path__ + "static/Bryndan_Write-20e48b2ec8c64b2a1ceb5b28d9bcc9d0.ttf";